export const createObj = (path: string, value: any): object => {
  let obj: any = {};
  let schema = obj;
  const keys = path.split(".");
  for (let i = 0; i < keys.length - 1; i++) {
    schema[keys[i]] = {};
    schema = schema[keys[i]];
  }
  schema[keys.pop()!!] = value;
  return obj;
};

export const countFilledProperties = (obj: object): FilledProperties => {
  const keys = Object.keys(obj);
  let totalNrProperties = keys.length;
  const filledAttributes = keys.reduce<number>((total, key) => {
    const currValue = (obj as any)[key];
    if (!currValue) {
      return total + 0;
    } else if (typeof currValue === "object") {
      const childFilledProps = countFilledProperties(currValue);
      totalNrProperties = totalNrProperties + (childFilledProps.total - 1); // -1 because the object itself already counts as 1 in the parent
      return total + childFilledProps.filled;
    } else {
      return total + 1;
    }
  }, 0);
  return { total: totalNrProperties, filled: filledAttributes };
};

export interface FilledProperties {
  total: number;
  filled: number;
}

export function flattenBidimensionalMap<T>(
  map: Map<string, Map<string, T>>,
  parser?: (item: T) => T
) {
  const flatMap = new Map<string, T>();

  for (const [primaryKey, secondaryMap] of map) {
    for (const [secondaryKey, item] of secondaryMap) {
      const parsedItem = parser ? parser(item) : item;
      flatMap.set(`${primaryKey},${secondaryKey}`, parsedItem);
    }
  }
  return flatMap;
}

export function unflattenBidimensionalMap<T>(flatMap: Map<string, T>) {
  const map = new Map<string, Map<string, T>>();

  for (const [key, item] of flatMap) {
    const [primaryKey, secondaryKey] = key.split(",");

    const subItem = map.get(primaryKey);
    if (subItem) {
      subItem.set(secondaryKey, item);
    } else {
      map.set(primaryKey, new Map([[secondaryKey, item]]));
    }
  }

  return map;
}

export function flattenMapOfLists<T>(map: Map<string, T[]>) {
  const list = [];

  for (const items of map.values()) {
    list.push(...items);
  }
  return list;
}

export const range = (nItems: number) => [...Array(nItems).keys()];
